// extracted by mini-css-extract-plugin
export default {"userSettingPage":"userSettingPage_userSettingPage__AqL5I","userBillingHolderAndInvitationHolder":"userSettingPage_userBillingHolderAndInvitationHolder__7ivyC"};